import React, { useState } from 'react';
import { PlusIcon, TrashIcon, SearchIcon, InfoIcon, FilterIcon } from 'lucide-react';
// Mock parts data
const mockPartsData = [{
  id: 'P001',
  reference: 'AIS-101-A',
  name: 'Control Panel',
  category: 'Electronics',
  unitPrice: 1250
}, {
  id: 'P002',
  reference: 'AIS-202-B',
  name: 'Gear Drive',
  category: 'Mechanical',
  unitPrice: 850
}, {
  id: 'P003',
  reference: 'AIS-303-C',
  name: 'Sprinkler Head',
  category: 'Irrigation',
  unitPrice: 45
}, {
  id: 'P004',
  reference: 'AIS-404-D',
  name: 'Drive Motor',
  category: 'Mechanical',
  unitPrice: 1100
}, {
  id: 'P005',
  reference: 'AIS-505-E',
  name: 'Pressure Gauge',
  category: 'Sensors',
  unitPrice: 75
}, {
  id: 'P006',
  reference: 'AIS-606-F',
  name: 'Solenoid Valve',
  category: 'Irrigation',
  unitPrice: 120
}, {
  id: 'P007',
  reference: 'AIS-707-G',
  name: 'GPS Module',
  category: 'Electronics',
  unitPrice: 550
}, {
  id: 'P008',
  reference: 'AIS-808-H',
  name: 'Tower Box',
  category: 'Structural',
  unitPrice: 350
}, {
  id: 'P009',
  reference: 'AIS-909-I',
  name: 'Span Pipe',
  category: 'Structural',
  unitPrice: 420
}, {
  id: 'P010',
  reference: 'AIS-010-J',
  name: 'End Gun',
  category: 'Irrigation',
  unitPrice: 980
}];
export function PartsSelectionStep({
  initialData = [],
  onUpdate
}) {
  const [selectedParts, setSelectedParts] = useState(initialData);
  const [searchQuery, setSearchQuery] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [showPartsSelector, setShowPartsSelector] = useState(false);
  // Filter parts based on search and category
  const filteredParts = mockPartsData.filter(part => {
    const matchesSearch = part.name.toLowerCase().includes(searchQuery.toLowerCase()) || part.reference.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = categoryFilter === 'all' || part.category === categoryFilter;
    return matchesSearch && matchesCategory;
  });
  // Get unique categories for filter dropdown
  const categories = ['all', ...new Set(mockPartsData.map(part => part.category))];
  const handleAddPart = part => {
    // Check if part is already selected
    const existingPartIndex = selectedParts.findIndex(p => p.id === part.id);
    if (existingPartIndex >= 0) {
      // If already selected, increase quantity
      const newParts = [...selectedParts];
      newParts[existingPartIndex].quantity += 1;
      setSelectedParts(newParts);
      onUpdate(newParts);
    } else {
      // Otherwise add as new with quantity 1
      const newParts = [...selectedParts, {
        ...part,
        quantity: 1
      }];
      setSelectedParts(newParts);
      onUpdate(newParts);
    }
  };
  const handleRemovePart = index => {
    const newParts = selectedParts.filter((_, i) => i !== index);
    setSelectedParts(newParts);
    onUpdate(newParts);
  };
  const handleQuantityChange = (index, newQuantity) => {
    if (newQuantity < 1) return;
    const newParts = [...selectedParts];
    newParts[index].quantity = newQuantity;
    setSelectedParts(newParts);
    onUpdate(newParts);
  };
  // Calculate total
  const total = selectedParts.reduce((sum, part) => sum + part.unitPrice * part.quantity, 0);
  return <div className="space-y-6" data-id="element-5226" data-mp="cg6kpg5ja7gk">
      <div className="text-white text-xl font-medium mb-6" data-id="element-5227" data-mp="heq4b9wnn75r">
        Select Spare Parts
      </div>
      <div className="bg-blue-900/30 rounded-xl p-5 border border-blue-800/30 mb-6" data-id="element-5228" data-mp="3fwdm1g0h7sm6">
        <div className="flex items-start" data-id="element-5229" data-mp="3fuaomawzux7f">
          <InfoIcon size={20} className="text-blue-400 mr-3 mt-0.5" data-id="element-5230" data-mp="3kuownsyli75g" />
          <div data-id="element-5231" data-mp="3pujnxxma8yr1">
            <h3 className="text-white font-medium mb-1" data-id="element-5232" data-mp="3pu1hy99tj65x">
              Spare Parts Selection Guide
            </h3>
            <p className="text-blue-200 text-sm" data-id="element-5233" data-mp="3umbew99cp6hp">
              Select the spare parts you need for your irrigation system. You
              can search by name or reference number and filter by category. Add
              multiple items and adjust quantities as needed.
            </p>
          </div>
        </div>
      </div>

      {/* Selected Parts List */}
      <div className="bg-slate-800/50 rounded-xl border border-blue-800/30" data-id="element-5234" data-mp="13n5ciq036u26">
        <div className="flex justify-between items-center p-4 border-b border-blue-800/30" data-id="element-5235" data-mp="13l2bzc1b5ij7">
          <h3 className="text-white font-medium" data-id="element-5236" data-mp="1hfv0gzz6e91x">Selected Parts</h3>
          <button onClick={() => setShowPartsSelector(true)} className="flex items-center px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-700 transition-colors" data-id="element-5237" data-mp="1cmsd59kzrvu6">
            <PlusIcon size={16} className="mr-1" data-id="element-5238" data-mp="1me6bhe17iplq" />
            Add Parts
          </button>
        </div>
        {selectedParts.length > 0 ? <div data-id="element-5239" data-mp="20cw52joti75c">
            <div className="grid grid-cols-12 gap-4 p-4 border-b border-blue-800/30 text-sm font-medium text-blue-300" data-id="element-5240" data-mp="20cmnnkhu98b9">
              <div className="col-span-1" data-id="element-5241" data-mp="5zeqhm6e4kmg">Ref</div>
              <div className="col-span-5" data-id="element-5242" data-mp="606as0ujevxf">Part Name</div>
              <div className="col-span-2" data-id="element-5243" data-mp="10jxjreplfom">Category</div>
              <div className="col-span-1 text-center" data-id="element-5244" data-mp="11v4g03gb3jy">Qty</div>
              <div className="col-span-2 text-right pr-8" data-id="element-5245" data-mp="2cndo9a2kft83">Price</div>
              <div className="col-span-1" data-id="element-5246" data-mp="2hmqmeqyw0mpz"></div>
            </div>
            <div className="p-2" data-id="element-5247" data-mp="2hm8euy6rym2r">
              {selectedParts.map((part, index) => <div key={index} className="grid grid-cols-12 gap-4 p-2 items-center" data-id="element-5248" data-mp="23uafhf2v84js" data-mpi={index}>
                  <div className="col-span-1 text-blue-300 text-sm" data-id="element-5249" data-mp="27wf9iex8736y">
                    {part.reference}
                  </div>
                  <div className="col-span-5 text-white" data-id="element-5250" data-mp="1tvkvngresa0w">{part.name}</div>
                  <div className="col-span-2 text-blue-300 text-sm" data-id="element-5251" data-mp="1ywinkl280ifl">
                    {part.category}
                  </div>
                  <div className="col-span-1" data-id="element-5252" data-mp="1ky28o6u7flmd">
                    <div className="flex items-center justify-center" data-id="element-5253" data-mp="1oxt3clmuqlw6">
                      <button onClick={() => handleQuantityChange(index, part.quantity - 1)} className="w-6 h-6 bg-slate-900/50 text-blue-300 rounded-l-md hover:bg-slate-900 hover:text-white" data-id="element-5254" data-mp="1p05m310fp0aa">
                        -
                      </button>
                      <input type="number" value={part.quantity} onChange={e => handleQuantityChange(index, parseInt(e.target.value) || 1)} className="w-10 h-6 bg-slate-900/50 border-y border-blue-800/30 text-white text-center focus:outline-none" min="1" data-id="element-5255" data-mp="w3wlf0i1h49u" />
                      <button onClick={() => handleQuantityChange(index, part.quantity + 1)} className="w-6 h-6 bg-slate-900/50 text-blue-300 rounded-r-md hover:bg-slate-900 hover:text-white" data-id="element-5256" data-mp="n4t2bwivgovc">
                        +
                      </button>
                    </div>
                  </div>
                  <div className="col-span-2 text-right text-white pr-8" data-id="element-5257" data-mp="1auwwlda67c9o">
                    ${(part.unitPrice * part.quantity).toFixed(2)}
                  </div>
                  <div className="col-span-1 flex justify-center" data-id="element-5258" data-mp="1127yrl7jlwwt">
                    <button onClick={() => handleRemovePart(index)} className="p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-5259" data-mp="1yiddzkvwdmlu">
                      <TrashIcon size={16} data-id="element-5260" data-mp="212ta9mt13wb9" />
                    </button>
                  </div>
                </div>)}
            </div>
            <div className="p-4 border-t border-blue-800/30 flex justify-end" data-id="element-5261" data-mp="262pg7rladxtg">
              <div className="w-64" data-id="element-5262" data-mp="2b0hgp9zzys99">
                <div className="flex justify-between items-center text-blue-300 mb-2" data-id="element-5263" data-mp="2az64clshkc6j">
                  <span data-id="element-5264" data-mp="2f343uxlq3p04">Subtotal:</span>
                  <span className="text-white" data-id="element-5265" data-mp="2ezzs9f5xhqzf">${total.toFixed(2)}</span>
                </div>
                <div className="border-t border-blue-800/30 pt-2 mt-2" data-id="element-5266" data-mp="2jzkz0brcb3mp">
                  <div className="flex justify-between items-center" data-id="element-5267" data-mp="2oyxj4oqttwll">
                    <span className="font-medium text-white" data-id="element-5268" data-mp="2ts9xm61skn0m">Total:</span>
                    <span className="text-xl font-bold text-white" data-id="element-5269" data-mp="2yq1znsw5hpij">
                      ${total.toFixed(2)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div> : <div className="p-8 text-center" data-id="element-5270" data-mp="37s1j0run15on">
            <p className="text-blue-300 mb-3" data-id="element-5271" data-mp="37ox9deyelhql">No parts selected yet</p>
            <button onClick={() => setShowPartsSelector(true)} className="inline-flex items-center px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors" data-id="element-5272" data-mp="3t0ne1u8s0rje">
              <PlusIcon size={18} className="mr-2" data-id="element-5273" data-mp="6tp1soe777xa" />
              Select Parts
            </button>
          </div>}
      </div>

      {/* Parts Selector Modal */}
      {showPartsSelector && <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" data-id="element-5274" data-mp="3aaxiv613q3qy">
          <div className="bg-slate-900 rounded-xl shadow-xl w-full max-w-4xl max-h-[80vh] overflow-hidden flex flex-col" data-id="element-5275" data-mp="35cvzsl3oe4fh">
            <div className="p-4 border-b border-blue-800/30 flex justify-between items-center" data-id="element-5276" data-mp="3k2blvns9hlou">
              <h3 className="text-lg font-medium text-white" data-id="element-5277" data-mp="3f9iip4cfylev">Select Parts</h3>
              <button onClick={() => setShowPartsSelector(false)} className="text-blue-300 hover:text-white" data-id="element-5278" data-mp="2rkfqx3o3fc6n">
                <span className="text-2xl" data-id="element-5279" data-mp="2mmnzeard1s2z">&times;</span>
              </button>
            </div>
            <div className="p-4 border-b border-blue-800/30 bg-slate-800/50 flex flex-wrap gap-4" data-id="element-5280" data-mp="123k7jbncj2gi">
              <div className="relative flex-1 min-w-[250px]" data-id="element-5281" data-mp="16utuu5lf9tp8">
                <SearchIcon size={18} className="absolute left-3 top-2.5 text-blue-400" data-id="element-5282" data-mp="16wdf07a78owa" />
                <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full bg-slate-900/70 border border-blue-800/30 rounded-lg pl-10 pr-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Search by name or reference..." data-id="element-5283" data-mp="s3l1bleefo6t" />
              </div>
              <div className="relative min-w-[200px]" data-id="element-5284" data-mp="1btnaa3k9rus1">
                <FilterIcon size={18} className="absolute left-3 top-2.5 text-blue-400" data-id="element-5285" data-mp="1bt3q0g75cuau" />
                <select value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)} className="w-full bg-slate-900/70 border border-blue-800/30 rounded-lg pl-10 pr-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-5286" data-mp="1ftxebaoi4b49">
                  {categories.map(category => <option key={category} value={category} data-id="element-5287" data-mp="2xm5op2jq6v8z">
                      {category === 'all' ? 'All Categories' : category}
                    </option>)}
                </select>
              </div>
            </div>
            <div className="overflow-auto flex-1" data-id="element-5288" data-mp="2npaugvuhjh0i">
              <table className="w-full border-collapse" data-id="element-5289" data-mp="2nq2oi28fp6oo">
                <thead className="bg-slate-800 sticky top-0" data-id="element-5290" data-mp="hwm84ojsru7c">
                  <tr data-id="element-5291" data-mp="lwmquldxirk7">
                    <th className="text-left p-3 text-blue-300 font-medium" data-id="element-5292" data-mp="lvv4m168266l">
                      Reference
                    </th>
                    <th className="text-left p-3 text-blue-300 font-medium" data-id="element-5293" data-mp="26f70s3samssn">
                      Name
                    </th>
                    <th className="text-left p-3 text-blue-300 font-medium" data-id="element-5294" data-mp="2g4qjn9g0amni">
                      Category
                    </th>
                    <th className="text-right p-3 text-blue-300 font-medium" data-id="element-5295" data-mp="2bcz03iv9ph6v">
                      Price
                    </th>
                    <th className="p-3" data-id="element-5296" data-mp="2q13b00o2wof3"></th>
                  </tr>
                </thead>
                <tbody data-id="element-5297" data-mp="2l3bfyxs50m6o">
                  {filteredParts.map(part => <tr key={part.id} className="border-b border-blue-900/30 hover:bg-slate-800/50" data-id="element-5298" data-mp="2z3cmasr68ltj">
                      <td className="p-3 text-blue-300" data-id="element-5299" data-mp="2u3zxw3knj6ou">{part.reference}</td>
                      <td className="p-3 text-white" data-id="element-5300" data-mp="14plcnt8ue1y3">{part.name}</td>
                      <td className="p-3 text-blue-300" data-id="element-5301" data-mp="14ptqbncshbac">{part.category}</td>
                      <td className="p-3 text-white text-right" data-id="element-5302" data-mp="zrjtz9fbw4n5">
                        ${part.unitPrice.toFixed(2)}
                      </td>
                      <td className="p-3 text-right" data-id="element-5303" data-mp="2zv2tgxv1w714">
                        <button onClick={() => handleAddPart(part)} className="px-3 py-1 bg-blue-600/30 text-blue-300 rounded hover:bg-blue-600 hover:text-white transition-colors" data-id="element-5304" data-mp="34sw1zxjttd4k">
                          Add
                        </button>
                      </td>
                    </tr>)}
                  {filteredParts.length === 0 && <tr data-id="element-5305" data-mp="3irc5zgqb0pj0">
                      <td colSpan={5} className="p-6 text-center text-blue-300" data-id="element-5306" data-mp="3nqp3qwiprh0d">
                        No parts found matching your search criteria
                      </td>
                    </tr>}
                </tbody>
              </table>
            </div>
            <div className="p-4 border-t border-blue-800/30 bg-slate-800/50 flex justify-end" data-id="element-5307" data-mp="1akvlcf90mx3">
              <button onClick={() => setShowPartsSelector(false)} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-5308" data-mp="5eagnrwpsmdd">
                Done
              </button>
            </div>
          </div>
        </div>}
    </div>;
}